import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { SrSalesOrderType } from '@plato/data/starrocks/types';
import { Link } from 'react-router-dom';
import { formatOrderId } from '../../../lib/order-helpers.ts';
import { useDialogs } from '../../dialogs/all-dialogs.tsx';

type Props = {
    transactionId: string;
    type: SrSalesOrderType;
};

function getTransactionUrl(type: SrSalesOrderType, id: string) {
    if (type === SrSalesOrderType.QUOTE) {
        return `/quotes/${encodeURIComponent(id)}`;
    }

    if (type === SrSalesOrderType.ORDER) {
        return `/orders/${encodeURIComponent(id)}`;
    }

    return ``;
}

export function QuoteOrderLink({ type, transactionId }: Props) {
    const { openOrderQuoteDetails } = useDialogs();
    const appConfig = useAppConfig();

    return (
        <Link
            className="text-blue-700 hover:underline text-sm"
            to={getTransactionUrl(type, transactionId)}
            onClick={(e) => {
                if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    openOrderQuoteDetails(type, transactionId);
                }

                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }}
        >
            {formatOrderId(appConfig, transactionId)}
        </Link>
    );
}

export function OrderLink(props: Omit<Props, 'type'>) {
    return <QuoteOrderLink type={SrSalesOrderType.ORDER} {...props} />;
}

export function QuoteLink(props: Omit<Props, 'type'>) {
    return <QuoteOrderLink type={SrSalesOrderType.QUOTE} {...props} />;
}
